export function formatTimestamp(
  timestamp: string | number | Date | null | undefined
) {
  if (!timestamp) {
    return '';
  }

  return new Date(timestamp).toLocaleString();
}
